import * as API from "@/api/index.js"

export default {
  name: "user-transfer",
  components: {

  },

  model:{
    prop:"selection",
    event:"change",
  },

  props: {
    selection: {

    },

    get_url: {
        type: String,
        default: "/omnis/system/user_role",   // 用户源数据接口路由
    },

    get_param:{
      type: Object,
      default: function () {
        return {}    // 用户源数据接口参数
      }
    },

    header_check_disabled:{
      type: Boolean,
      default: false,   // 头部全选 复选框禁用
    },
  },

  data() {

    return {
      data_selected: [],   // 选择的数据
      filterMethod(query, item) {
           return (item.pinyin.indexOf(query) > -1) || (item.label && item.label.indexOf(query) > -1) || (item.username.indexOf(query) > -1);
      },
      loading: false,
      data_all: [],   // 组数据
    }
  },
  mounted() {

    this.get_all_data();

  },

  computed: {},

  watch: {

    get_param: {
      handler(data) {
        this.all_data_req();
      },
      deep: true
    },

    selection: {
      handler(data){
        this.data_selected = data;
      },
      deep:true,
    },

    data_selected: {
      handler(data){
        let data_details = this.data_all.filter(item => data.indexOf(item.key) > -1)
        this.$emit("change", data);
        this.$emit("data_change", data_details);
      },
      deep:true,
    },

  },

  methods: {
    get_all_data(){
      if (this.data_all.length === 0){
        this.all_data_req()
      }
    },

    async all_data_req() {
        this.loading = true
        const response = await API.GET(this.get_url, this.get_param)
        this.loading = false
        let data = response.data
        if (data.success) {
          this.data_all = []
          data.data.forEach((item) => {
            this.data_all.push({key: item.userid, label: item.nick + "(" + item.username + ")", pinyin: item.spy, username: item.username})
          })
          this.data_selected = this.selection;

        }
      },

  },

}



// WEBPACK FOOTER //
// ./src/omnis-business/user-transfer/user-transfer.js